import React from 'react';
import PropTypes from 'prop-types';
import './ButtonIcon.css';

function ButtonIconV2({ onClick, icon, label, className, classNameLabel, style }) {
  return (
    <div className={`flexRow align button-icon-v2 ${className} `} style={{...style}} onClick={onClick}>
      {icon}
      <span className={`type-medium button-icon-v2-label ${classNameLabel}`}>{label}</span>
    </div>
  );
}

ButtonIconV2.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  classNameLabel: PropTypes.string,
  style: PropTypes.object,
}

export default ButtonIconV2;
